var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app","c_name":"MobileApp"}},[_c('TopMobile'),_c('router-view'),_c('BottomMobile'),_c('WxQQWebGo',{directives:[{name:"show",rawName:"v-show",value:(_vm.isWxQQ),expression:"isWxQQ"}]})],1)}
var staticRenderFns = []

export { render, staticRenderFns }